import _ from 'lodash';
import moment from 'moment';
import {writable} from 'svelte/store';
import storage from './storage.js';

// хранилище параметров
const PARAMETERS = {};
export const parameter = (key, defaults = '') => {
    if (PARAMETERS[key]) {
        return PARAMETERS[key];
    }
    const store = writable(defaults);
    
    return PARAMETERS[key] = store;
};

export const network = {
    // request section
    
    request: async (data) => {
        let param = {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            domain: 'https://api.trademaster.pro/plisse/',
            endpoint: '',
            params: null,
            body: null,
        };
        data = _.extend(param, data);
    
        let url = data.domain + data.endpoint + '?apikey=' + APP_KEY + (data.params ? '&' + data.params : '');
        let response = await fetch(url, {
            method: data.method.toUpperCase(),
            headers: data.headers,
            cache: 'no-cache',
            body: data.body
        });
        
        return await response.json();
    },
    
    get: async (endpoint, data) => {
        return await network.request({method: 'post', endpoint, params: (new URLSearchParams(data)).toString()});
    },
    
    post: async (endpoint, data) => {
        return await network.request({method: 'post', endpoint, body: formdata});
    },

    proxy: async (query, isOne = false) => {
        let fd = new FormData();
            fd.append('query', query.trim());
        
        if (isOne) {
            fd.append('one', 'true');
        }
    
        let url = 'https://api.trademaster.pro/proxy?apikey=' + APP_KEY;
        let response = await fetch(url, {method: 'POST', cache: 'no-cache', body: fd});
        
        return await response.json();
    },

    fetch_proxy: async (query, params = {}) => {
        return await network.get('proxy', _.merge({}, {query}, params));
    },

    getPlanListRange: async (user_id) => {
        const query = `                  
        EXEC planDvizhDeneg 
            @userId=${user_id}      
    `;
        const result = await network.proxy(query);

        return result;
    },
    getPayListRange: async (user_id, date1, date2) => {
        // TEMP: removed hardcoded vid filter for diagnosis (was @vid = 2; using -1 to request all statuses)
        const query = `                  
        EXEC oplatDvizhDenegApp 
            @userId=${user_id},          
            @data1='${date1}',
            @data2='${date2}',
            @vid = -1,
            @ds = -1            
    `;
        const result = await network.proxy(query);
        return result;
    },
    
    getOrder: async (params) => {
        const query1 = `
            EXEC viborkaActual
                @nomer = '${params.id}',
                @vid = '${params.vid}',
                @all = 1
        `;
        const query2 = `
            EXEC getTV @idSklad = 0
        `;
        const query3 = `
            EXEC kontakti @idKontr = ${params.user_kontr}
        `;
        
        return {
            order: await network.proxy(query1, true),
            tv: await network.proxy(query2),
            kontakti: await network.proxy(query3),
        };
    },
    
    saveKontakt: async (params) => {
        let query = '';
        
        if (params.idKontakt) {
            query = `
                EXEC saveKontakt
                    @idKontakt = '${params.idKontakt}',
                    @idKontr = '${params.user_kontr}',
                    @nameKontakt = '${params.nameKontakt}',
                    @fioKontakt = '',
                    @adresKontakt = '${params.adresKontakt}',
                    @telefonKontakt = '${params.telefonKontakt}',
                    @shemaKontakt = 0,
                    @other1Kontakt = '${params.other1Kontakt}',
                    @other2Kontakt = '${params.other2Kontakt}',
                    @actualnost = '${params.actualnost}'
            `;
        } else {
            query = `
                EXEC addKontakts
                    @idKontr = '${params.user_kontr}',
                    @nameKontakt = '${params.nameKontakt}',
                    @fioKontakt = '',
                    @adresKontakt = '${params.adresKontakt}',
                    @telefonKontakt = '${params.telefonKontakt}',
                    @shemaKontakt = 0,
                    @other1Kontakt = '${params.other1Kontakt}',
                    @other2Kontakt = '${params.other2Kontakt}'
            `;
        }
    
        let result = await network.proxy(query, true),
            idKontakt = (result.idKontakt ? result.idKontakt : -1);
    
        query = `
            EXEC viborkaUpdateKont
                @nom = '${params.nom}',
                @vid = '${params.vid}',
                @idKontakt = '${idKontakt}'
        `;
        
        return await network.proxy(query, true);
    },
    
    saveDelivery: async (params) => {
        let query = `
            EXEC viborkaUpdateTipDostTV
                @nom = '${params.nom}',
                @vid = '${params.vid}',
                @tv = '${params.tv}',
                @tipDost = '${params.dost}'
        `;
    
        return await network.proxy(query, true);
    },
    
    createTovar: async (params) => {
        const query = `
            EXEC addTovarViborka
                @name = '${params.problem}',
                @opis = '',
                @artikul = '',
                @edIzmer = 'шт.',
                @vStrukture= '2',
                @foto_small = '',
                @ind1 = '${params.vin}',
                @ind2 = '${params.tipTask}',
                @ind3 = '',
                @ind4 = '',
                @ind5 = '',
                @komment = '${params.description}',
                @idSklad = ${params.user_sklad},
                @urlico = 0,
                @idKontr = ${params.user_kontr},
                @userId = ${params.user_id},
                @dataDo = '${params.deadline}',
                @userName = '${params.userName}',
                @idKontakt ='${params.idKontakt}'  
                
                
        `;
    
        return await network.proxy(query, true);
    },

    getMaterial: async () => {
        const query = `
            EXEC getMaterial
                @vstr = 1
        `;
        
        return await network.proxy(query);
    },
    getProjects: async () => {
        const query = `
            EXEC ProjectsLiveSearch
                @query ='***'
                ,@start=0
                ,@limit=1000
                ,@page=1
        `;

        return await network.proxy(query);
    },

    getAnalitiks: async () => {
        const query = `
            EXEC getAnalitik 
        `;

        return await network.proxy(query);
    },

    getKontragents: async () => {
        const query = `
            EXEC getMaterial
                @vstr = 1
        `;

        return await network.proxy(query);
    },
    
    // * proxy section
    // cdn section
    
    cdn: async (formdata) => {
        let url = 'https://api.trademaster.pro/cdn/post?apikey=' + APP_KEY;
        let response = await fetch(url, {method: 'POST', body: formdata});
        
        return await response.json();
    },
    
    // * cdn section
    // api section
    
    api: async (body = [], params = null) => {
        let url = 'https://app.stratagema.online/api/chat.php' + (params ? '?' + (new URLSearchParams(params)).toString() : '');
        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            cache: 'no-cache',
            body: JSON.stringify(body),
        });
    
        return await response.json();
    },
    
    getChatMessages: async (order_id, user_id, last_msg_id) => {
        return await network.api([], {method: 'read', order: order_id, user: user_id, last_msg_id});
    },
    
    getChatMessagesCount: async (order_ids, user_id) => {
        return await network.api([], {method: 'count', orders: (Array.isArray(order_ids) ? order_ids.join('|') : order_ids), user: user_id});
    },
    
    sendChatMessage: async (order_id, user_id, user_name, message, type) => {
        return await network.api([], {method: 'write', order: order_id, user: user_id, name: user_name, message, type});
    },
    
    sendChatToken: async (token) => {
        const user = store('credential', 'getAuth'),
              user_id = user.get().id;
        
        return await network.api([], {method: 'save_token', user: user_id, token});
    },

    deleteOrder: async (nomer, vid) => {
        const query = `EXEC finAktulnost @nomer = ${nomer}, @operation= ${vid}`;
        return {
            finAktulnost: await network.proxy(query),
        };
    },

    toChek: async (nomer, operation, vid) => {
        const vidEsc = String(vid ?? '').replace(/'/g, "''");
        const query = `EXEC toChek @nomer = ${+nomer}, @operation = ${+operation}, @vid = '${vidEsc}'`;
        return await network.proxy(query);
    },

    createOrder: async (query) => {
        return await network.fetch_proxy(query);
    },

    updateOrder: async (query) => {
        return await network.fetch_proxy(query);
    },
    // * api section
}


// работа с хранением данных
const STORES = {};
export const store = (name, endpoint = null, value = '{}') => {
    if (STORES[name]) {
        return STORES[name];
    }
    
    let loading = writable(false),
        data = writable(JSON.parse(storage.getItem(name) ?? value));
    
    async function load(params) {
        if (endpoint) {
            loading.set(true);
            
            let result = await network.get(endpoint, params);
            if (result) {
                data.set(result);
                storage.setItem(name, JSON.stringify(result));
            } else {
                data.set({});
            }
            loading.set(false);
            
            return result;
        }
        
        return false;
    }
    
    function set(params) {
        data.set(params);
        storage.setItem(name, JSON.stringify(params));
    }
    
    function get() {
        let $val;
        data.subscribe($ => $val = $)();
        
        return $val;
    }
    
    function remove() {
        data.set('');
        storage.removeItem(name);
    }
    
    return STORES[name] = {
        subscribe: data.subscribe,
        get: get,
        set: data.set,
        update: data.update,
        load: load,
        loading: () => loading,
        save: set,
        remove: remove,
    };
};


export const uploadFileToCdn = async (file, uniqOff = false) => {
    const buffer = await file.arrayBuffer();
    const query = new URLSearchParams({ back_door_with_name: 'mifim-online' });
    const url = `https://api.trademaster.pro/cdn/post?${query}`;

    const fd = new FormData();
    fd.append('file', new Blob([buffer]), file.name);
    if (uniqOff) fd.append('uniqOff', 'true');

    const response = await fetch(url, { method: 'POST', cache: 'no-cache', body: fd });
    return await response.json();
};